import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = [ 'input', 'countryCode' ]
  static values = { code: String, identifier: String }

  connect () {
    this.loadTel()
  }

  loadTel(){
    let iti = window.intlTelInput(this.inputTarget, {
      initialCountry: this.codeValue,
      formatOnDisplay: true,
      separateDialCode: true,
      autoPlaceholder: 'polite',
      geoIpLookup: callback => {
        fetch('https://ipapi.co/json')
          .then(res => res.json())
          .then(data => callback(data.country_code))
      },
      utilsScript:
        'https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.6/build/js/utils.js'
    })
    this.countryCodeTarget.value = iti.getSelectedCountryData().iso2
    this.inputTarget.addEventListener('countrychange', () => {
      const previousCountry = this.countryCodeTarget.value
      this.countryCodeTarget.value = null
      this.countryCodeTarget.value = iti.getSelectedCountryData().iso2

      // Vérifier si ce champ est une source (utilise maintenant phone_identifier)
      if (this.isSourceField()) {
        this.syncDestinationPhoneInputs(this.countryCodeTarget.value)
      }
    });
  }

  // Détermine si ce champ est un champ source en utilisant phone_identifier ou chain-index 0
  isSourceField() {
    // Vérifier si c'est un champ avec chain-index 0 (premier dans la chaîne)
    const chainIndex = this.inputTarget.dataset.chainIndex
    if (chainIndex === '0') {
      return true
    }

    // Ou vérifier l'identifier value si elle existe
    return this.hasIdentifierValue && this.identifierValue === 'source'
  }

  // Détermine si un contrôleur est associé à un champ de destination
  isDestinationController(controller) {
    if (!controller.inputTarget) return false;

    // Vérifier si c'est un champ avec chain-index > 0
    const chainIndex = controller.inputTarget.dataset.chainIndex
    if (chainIndex && chainIndex !== '0') {
      return true
    }

    // Ou vérifier l'identifier value
    return controller.hasIdentifierValue && controller.identifierValue === 'destination'
  }

  syncDestinationPhoneInputs(countryCode) {
    // Trouver tous les contrôleurs phone-input
    const phoneInputControllers = this.application.controllers.filter(
      controller => controller.context.identifier === 'phone-input' && controller !== this
    );

    // Mettre à jour uniquement les contrôleurs qui sont des destinations
    phoneInputControllers.forEach(controller => {
      if (this.isDestinationController(controller) && controller.iti) {
        controller.iti.setCountry(countryCode);
      }
    });
  }
}
